define('fukit/view/block/permission.dimmer.view',['require','exports','module','underscore','marionette','backbone','uikit/uikit'],function(require, exports, module) {
  //prettier-ignore
  var _                    = require('underscore'),
      Mn                   = require('marionette'),
      Backbone             = require('backbone'),
      UIKit                = require('uikit/uikit'),
      currentRouteFragment = Backbone.history.fragment,
      previousRouteFragment;

  Backbone.history.on('route', function() {
    previousRouteFragment = currentRouteFragment;
    currentRouteFragment = Backbone.history.fragment;
  });

  var PermissionDimmerView = UIKit.Dimmer2.extend({
    options: _.extend({}, UIKit.Dimmer2.prototype.options, {
      inverted: true,
      page: true,
    }),

    content: function() {
      return {
        content: {
          type: UIKit.ComponentsContainerView,
          components: [
            _.extend(
              {
                type: UIKit.Header,
                tagName: 'h2',
                text: 'Access Denied',
                subText: 'You do not have the necessary permissions to access this page.',
              },
              Mn._getValue(this.getOption('header'), this)
            ),
            _.extend(
              {
                type: UIKit.ComponentsContainerView,
                spacing: 'uptight',
                childView: UIKit.Button,
                components: [
                  {
                    icon: 'reply',
                    text: 'Back to Home',
                    onPress: function() {
                      Backbone.history.navigate('', { trigger: true });
                    },
                    behaviors: {
                      CloseDimmerBehavior: {
                        behaviorClass: UIKit.Dimmer2.CloseDimmerBehavior,
                      },
                    },
                  },
                  {
                    icon: 'call',
                    text: 'Get Help',
                    onPress: function() {
                      window.open('https://support.cayuse.com', '_blank');
                    },
                  },
                ],
              },
              Mn._getValue(this.getOption('actions'), this)
            ),
          ],
        },
      };
    },
  });

  module.exports = PermissionDimmerView;
});

